"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var TabStyles_1 = require("../../styles/TabStyles");
var Overlay_1 = require("../../utils/Overlay");
exports.DefaultMaxWidth = 300;
/** This is padding between the anchor client rect boundary and the tooltip overlay boundary. */
exports.AnchorClientRectPadding = 6;
exports.BorderWidth = TabStyles_1.TabStyles.Sizing.BorderWidth;
exports.Padding = 12;
exports.AggregateTooltipPadding = 2 * (exports.BorderWidth + exports.Padding);
exports.ContentWrapperStyle = {
    backgroundColor: TabStyles_1.TabStyles.Colors.White,
    borderColor: TabStyles_1.TabStyles.Colors.L5,
    borderRadius: TabStyles_1.TabStyles.Sizing.BorderRadius,
    borderStyle: 'solid',
    borderWidth: exports.BorderWidth,
    boxShadow: TabStyles_1.TabStyles.Shadow.Standard,
    boxSizing: 'border-box',
    display: 'block',
    fontSize: TabStyles_1.TabStyles.Typography.Sizing.Default,
    lineHeight: 'normal',
    padding: exports.Padding,
};
var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition["TopLeftCorner"] = "TopLeftCorner";
    TooltipPosition["Top"] = "Top";
    TooltipPosition["TopRightCorner"] = "TopRightCorner";
    TooltipPosition["Right"] = "Right";
    TooltipPosition["BottomRightCorner"] = "BottomRightCorner";
    TooltipPosition["Bottom"] = "Bottom";
    TooltipPosition["BottomLeftCorner"] = "BottomLeftCorner";
    TooltipPosition["Left"] = "Left";
})(TooltipPosition = exports.TooltipPosition || (exports.TooltipPosition = {}));
exports.TooltipPositionInfoMap = (_a = {},
    _a[TooltipPosition.TopLeftCorner] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.top },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.bottom },
    },
    _a[TooltipPosition.Top] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.top },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.bottom },
    },
    _a[TooltipPosition.TopRightCorner] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.top },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.bottom },
    },
    _a[TooltipPosition.Right] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.centerY },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.centerY },
    },
    _a[TooltipPosition.BottomRightCorner] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.bottom },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.top },
    },
    _a[TooltipPosition.Bottom] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.bottom },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.centerX, vertical: Overlay_1.VerticalOriginOption.top },
    },
    _a[TooltipPosition.BottomLeftCorner] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.bottom },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.top },
    },
    _a[TooltipPosition.Left] = {
        anchorOrigin: { horizontal: Overlay_1.HorizontalOriginOption.left, vertical: Overlay_1.VerticalOriginOption.centerY },
        stackedOrigin: { horizontal: Overlay_1.HorizontalOriginOption.right, vertical: Overlay_1.VerticalOriginOption.centerY },
    },
    _a);
//# sourceMappingURL=TooltipConsts.js.map